import {
  Component,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { TelesuiviGraphiqueFuitesComponent } from '../telesuivi-graphique/telesuivi-graphique-fuites/telesuivi-graphique-fuites.component';
import { TuiInputDateRangeModule } from '@taiga-ui/legacy';
import { TuiDay, TuiDayLike, TuiDayRange } from '@taiga-ui/cdk';
import { FormsModule } from '@angular/forms';
import { TuiButton, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { TelesuiviGraphiqueObservanceEtIahrComponent } from '../telesuivi-graphique/telesuivi-graphique-observance-et-iahr/telesuivi-graphique-observance-et-iahr.component';
import { Observance } from '../../models/observance';
import { Patient } from '../../models/patient';
import { ObsPipe } from '../../pipes/obs.pipe';
import { IahResiduelPipe } from '../../pipes/iah-residuel.pipe';
import { FuitesPipe } from '../../pipes/fuites.pipe';

@Component({
  selector: 'app-telesuivi-card',
  standalone: true,
  imports: [
    FormsModule,
    TelesuiviGraphiqueFuitesComponent,
    TelesuiviGraphiqueObservanceEtIahrComponent,
    TuiInputDateRangeModule,
    TuiButton,
    TuiCardLarge,
    TuiSurface,
    ObsPipe,
    IahResiduelPipe,
    FuitesPipe,
  ],
  templateUrl: './telesuivi-card.component.html',
  styleUrl: './telesuivi-card.component.scss',
})
export class TelesuiviCardComponent implements OnInit {
  @Input() patient: Patient | undefined;

  protected readonly maxLength: TuiDayLike = { month: 12 };

  // Semaine dernière
  protected periodeSemaineDerniere = new TuiDayRange(
    TuiDay.currentLocal().append({ day: -6 }),
    TuiDay.currentLocal(),
  );

  // Deux dernières semaines
  protected periodeDeuxDernieresSemaines = new TuiDayRange(
    TuiDay.currentLocal().append({ day: -13 }),
    TuiDay.currentLocal(),
  );

  // Mois dernier
  protected periodeMoisDernier = new TuiDayRange(
    TuiDay.currentLocal().append({ month: -1, day: 1 }),
    TuiDay.currentLocal(),
  );

  // Deux derniers mois
  protected periodeDeuxDerniersMois = new TuiDayRange(
    TuiDay.currentLocal().append({ month: -2, day: 1 }),
    TuiDay.currentLocal(),
  );

  // Deux derniers mois
  protected periodeLAnneeDerniere = new TuiDayRange(
    TuiDay.currentLocal().append({ year: -1, month: 0, day: 1 }),
    TuiDay.currentLocal(),
  );

  protected periode: WritableSignal<TuiDayRange> = signal(
    this.periodeMoisDernier,
  );

  protected moyenneObservance: WritableSignal<Observance | undefined> =
    signal(undefined);

  protected miseAJourMoyenneObservance() {
    this.moyenneObservance.set(
      this.patient?.observanceMoyenne(
        new Date(
          this.periode().from.year,
          this.periode().from.month,
          this.periode().from.day,
        ),
        new Date(
          this.periode().to.year,
          this.periode().to.month,
          this.periode().to.day,
        ),
      ),
    );
  }

  ngOnInit(): void {
    this.miseAJourMoyenneObservance();
  }

  changePeriode(periode: TuiDayRange) {
    this.periode.set(periode);
    this.miseAJourMoyenneObservance();
  }
}
